import React from 'react'
import InstitutionsCom from '../../components/Institutions/InstitutionsCom'

const Institutions = () => {
  return (
    <div><InstitutionsCom/></div>
  )
}

export default Institutions